import { FC } from "react";
import TriggerSvg from "../../public/icons/Trigger.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const TriggerIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><TriggerSvg/></span>;
